import React from "react";

import config from "../../config";
import JSONLDTag from "./JSONLDTag";

const leasingOfferData = ({ grossRate }) => ({
  "@type": "Offer",
  price: grossRate?.price,
  priceCurrency: grossRate?.currency,
});

const JSONLDCar = ({ product }) => {
  const {
    title, subtitle, imageUrl, leasingOffer = {}, offerUrl, brand,
  } = product;
  const data = {
    "@type": "Car",
    name: title,
    description: subtitle,
    image: imageUrl,
    offers: leasingOfferData(leasingOffer),
    url: `${config.siteRoot}${offerUrl}`,
    brand: {
      "@type": "Brand",
      name: brand,
    },
  };
  return <JSONLDTag type="Car" data={data} />;
};

export default JSONLDCar;
